import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { GenActiveCartService } from '../../cart/core/facade/active-cart.service';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { GenShippingGroup } from 'src/app/generac/models/cart.model';
import { GenCheckoutService } from 'src/app/generac/services/checkout.service';
import { GenCartType } from 'src/app/generac/enums/cart-type.enum';

@Component({
    selector: 'gen-checkout-finished-goods',
    templateUrl: './checkout-finished-goods.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenCheckoutFinishedGoodsComponent {
  cartCode: string;
  purchaseOrderNumber: string;
  skipPaymentTypeStep: boolean = false;
  cartHasServiceParts: boolean = false;

  shippingGroup$: Observable<GenShippingGroup> = this.activeCartFacade.getActive().pipe(
    tap(cart => this.checkoutService.disableCheckoutSteps(cart?.cartTypes, cart?.engineReplacement)),
    tap(cart => this.skipPaymentTypeStep = cart?.wellsFargoCart),
    tap(cart => this.cartCode = cart.code),
    tap(cart => this.purchaseOrderNumber = cart.purchaseOrderNumber),
    switchMap(cart => of(cart.shippingGroups) as Observable<GenShippingGroup[]>),
    tap((shippingGroups: GenShippingGroup[]) => this.cartHasServiceParts = shippingGroups.some(sg => sg.cartTypes[0] === GenCartType.SERVICE_PARTS.toString())),
    map((shippingGroups: GenShippingGroup[]) => shippingGroups.filter(sg => sg.cartTypes[0] === GenCartType.FINISHED_GOODS.toString())),
    switchMap(shippingGroups => of(shippingGroups[0])),
  )

  constructor(
    protected checkoutStepService: CheckoutStepService,
    protected activatedRoute: ActivatedRoute,
    protected activeCartFacade: GenActiveCartService,
    private checkoutService: GenCheckoutService,
  ) {
  }
}
